import React, { useRef, useState } from 'react';
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Chip,
  IconButton,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

import { formatPrice } from 'utils/helpers';
import EditIcon from 'public/icons/edit-purple.svg';
import styles from 'styles/components/Wishlist.module.scss';

const useStyles = makeStyles({
  root: {
    width: 300,
    marginTop: 5,
    borderRadius: 10,
    boxShadow: '0 2px 5px 0 rgba(91, 0, 219, 0.41) !important',
    paddingBottom: 0,
  },

  button: {
    '&:hover': {
      cursor: 'default',
      backgroundColor: 'transparent',
    },
  },

  media: {
    height: 200,
  },

  body1: {
    fontSize: 16,
  },

  body2: {
    wordBreak: 'break-word',
  },

  h5: {
    marginLeft: '0px !important',
    marginBottom: '20px !important',
  },
});

const WishCardPreview = ({ wish, setWish }) => {
  const [preview, setPreview] = useState(null);
  const fileRef = useRef(null);
  const classes = useStyles();

  return (
    <Card classes={{ root: classes.root }} className={clsx(styles.card, styles.noHover)}>
      <CardActionArea className={classes.button} disableRipple>
        <input
          style={{ display: 'none' }}
          ref={fileRef}
          type="file"
          name="image"
          onChange={e => {
            if (preview) URL.revokeObjectURL(preview);

            const file = e.target.files[0];

            const preview = URL.createObjectURL(file);

            setPreview(preview);
            setWish(prevState => ({ ...prevState, image: file }));
          }}
          accept="image/jpg, image/jpeg, image/png"
        />

        <CardMedia className={classes.media} image={preview || wish.image_url} title={wish.name} />

        {wish.kind === 'crowdfunding' && (
          <Chip color="primary" label="Crowdfunding" className={styles.chip} />
        )}

        <div style={{ position: 'absolute', right: 5, top: 5 }}>
          <IconButton
            style={{ background: '#c8ccd9' }}
            onClick={() => fileRef.current.click()}
            className={styles.editIcon}
          >
            <EditIcon />
          </IconButton>
        </div>

        <CardContent>
          <Typography className={classes.h5} paragraph variant="h5" component="h2">
            {wish.name}
          </Typography>

          <Typography
            className={classes.body2}
            paragraph
            variant="body2"
            color="textSecondary"
            component="p"
          >
            {wish.description}
          </Typography>

          <Typography className={classes.body1} color="secondary" component="span">
            {formatPrice(wish.price)}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default WishCardPreview;
